@let key_result = vm();

<article class="okr-key-result" [class.okr-key-result-management]="layout() === 'management'">
  <div class="okr-key-result-top">
    <h4 class="okr-key-result-title">{{ key_result.title }}</h4>
    <div class="okr-kr-top-right">
      <span class="okr-category-chip">{{ key_result.category }}</span>
      @if (key_result.show_score_chip) {
        <span
          class="okr-score-chip"
          [class.okr-score-chip-good]="key_result.score_state === 'good'"
          [class.okr-score-chip-mid]="key_result.score_state === 'mid'"
          [class.okr-score-chip-low]="key_result.score_state === 'low'"
        >
          {{ key_result.scoring === null ? '—' : (key_result.scoring | number: '1.0-1') }}
        </span>
      }
      @if (show_options()) {
        <button mat-icon-button type="button" class="small-icon-button" [matMenuTriggerFor]="kr_menu" aria-label="Acciones del Key Result">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #kr_menu="matMenu">
          @if (can_update()) {
            <button mat-menu-item type="button" (click)="edit.emit()">Editar</button>
          }
          @if (can_open_variable_condition_dialog()) {
            <button mat-menu-item type="button" (click)="openVariableConditionDialog()">
              <mat-icon>tune</mat-icon>
              <span>Modificar parámetros de la métrica</span>
            </button>
          }
          @if (can_delete()) {
            <button mat-menu-item type="button" (click)="delete.emit()">Eliminar</button>
          }
          <button mat-menu-item type="button" (click)="openIngestHelp()">
            <mat-icon>code</mat-icon>
            <span>Cómo enviar datos (devs)</span>
          </button>
        </mat-menu>
      }
    </div>
  </div>

  @if (key_result.show_no_metric_data) {
    <div class="okr-empty-alert">
      <div class="okr-empty-alert-main">
        <mat-icon>hourglass_empty</mat-icon>
        <span>No hay datos aún</span>
      </div>
      @if (show_options()) {
        <button
          mat-icon-button
          type="button"
          class="small-icon-button okr-empty-dev-button"
          matTooltip="Cómo enviar datos (devs)"
          aria-label="Cómo enviar datos a la métrica"
          (click)="openIngestHelp()"
        >
          <mat-icon>code</mat-icon>
        </button>
      }
    </div>
  } @else {
    <div class="okr-metrics-row">
      <div class="okr-metric-box okr-metric-box-wide">
        <span class="okr-metric-label">Valor actual</span>
        <span class="okr-trend-value">
          {{ key_result.current_value === null ? '—' : (key_result.current_value | number: '1.0-2')
          }}{{ key_result.unit ? ' ' + key_result.unit : '' }}
          @if (key_result.show_trend) {
            @if (key_result.trend_direction === 'up') {
              <mat-icon
                [class.okr-trend-good]="key_result.trend_semantic_class === 'good'"
                [class.okr-trend-bad]="key_result.trend_semantic_class === 'bad'"
                [class.okr-trend-flat]="key_result.trend_semantic_class === 'neutral'"
                >trending_up</mat-icon
              >
            } @else if (key_result.trend_direction === 'down') {
              <mat-icon
                [class.okr-trend-good]="key_result.trend_semantic_class === 'good'"
                [class.okr-trend-bad]="key_result.trend_semantic_class === 'bad'"
                [class.okr-trend-flat]="key_result.trend_semantic_class === 'neutral'"
                >trending_down</mat-icon
              >
            } @else {
              <mat-icon class="okr-trend-flat">trending_flat</mat-icon>
            }
            @if (key_result.trend_percent === null) {
              <span class="okr-trend-percent okr-trend-percent-neutral">—</span>
            } @else {
              <span
                class="okr-trend-percent"
                [class.okr-trend-percent-good]="key_result.trend_semantic_class === 'good'"
                [class.okr-trend-percent-bad]="key_result.trend_semantic_class === 'bad'"
                [class.okr-trend-percent-neutral]="key_result.trend_semantic_class === 'neutral'"
                [matTooltip]="key_result.trend_tooltip"
              >
                {{ key_result.trend_percent > 0 ? '+' : '' }}{{ key_result.trend_percent | number: '1.0-2' }}%
              </span>
            }
          }
        </span>
        @if (
          key_result.show_threshold_bar &&
          key_result.bar_current_pct !== null &&
          key_result.bar_acceptable_pct !== null &&
          key_result.bar_good_pct !== null
        ) {
          <div class="okr-range">
            <div
              class="okr-range-fill"
              [class.okr-range-fill-good]="key_result.current_state === 'good'"
              [class.okr-range-fill-mid]="key_result.current_state === 'mid'"
              [class.okr-range-fill-low]="key_result.current_state === 'low'"
              [style.width.%]="key_result.bar_current_pct"
            ></div>
            <span class="okr-range-marker okr-range-marker-acceptable" [style.left.%]="key_result.bar_acceptable_pct"></span>
            <span class="okr-range-marker okr-range-marker-good" [style.left.%]="key_result.bar_good_pct"></span>
          </div>
          <div class="okr-range-labels">
            <span [matTooltip]="'Es el valor con el que se inició el periodo'">
              Inicio: {{ key_result.worst_value | number: '1.0-2' }}{{ key_result.unit ? ' ' + key_result.unit : '' }}
            </span>
            <span> Aceptable: {{ key_result.acceptable_value | number: '1.0-2' }}{{ key_result.unit ? ' ' + key_result.unit : '' }} </span>
            <span>Óptimo: {{ key_result.good_value | number: '1.0-2' }}{{ key_result.unit ? ' ' + key_result.unit : '' }}</span>
          </div>
        }
      </div>
    </div>
  }

  @if (key_result.show_timeline) {
    <div class="okr-timeline">
      <span>Start</span>
      <div class="okr-timeline-track">
        <div class="okr-timeline-fill" [style.width.%]="key_result.timeline_pct"></div>
      </div>
      <span>End</span>
    </div>
  }

  @if (key_result.show_last_updated || key_result.visualization_chart) {
    <div class="okr-kr-footer">
      @if (key_result.show_last_updated) {
        <span class="okr-last-updated">
          Última actualización via API del valor de métrica: {{ key_result.last_updated_label }}
          @if (key_result.is_stale_update) {
            <mat-icon
              color="warn"
              class="okr-stale-warning-icon"
              [matTooltip]="layout() === 'management' ? 'Sin actualización en más de 30 días' : 'Sin actualización en más de 3 días'"
              >warning</mat-icon
            >
          }
        </span>
      }
      @if (key_result.visualization_chart) {
        <button type="button" class="okr-eye-button" [matTooltip]="'Ver visualización'" (click)="openVisualization()">
          <mat-icon>visibility</mat-icon>
        </button>
      }
    </div>
  }
</article>
